// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageCircle01Icon from "@/assets/icons/message-circle-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageCircle01IconProps = Omit<IconProps, "name">;

export function MessageCircle01Icon(props: MessageCircle01IconProps): React.ReactNode {
  return <Icon name={messageCircle01Icon} {...props} />;
}
